module.exports = __webpack_public_path__ + "static/media/feefo-logo.9c55a83b.svg";